import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import DialogTitle from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/DialogTitle';
import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import DialogContent from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/DialogContent';
import Subtitle from 'Components/ComponentLibrary/Atoms/Text/Subtitle';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { DialogActions } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import RoundedButton from 'Components/ComponentLibrary/Atoms/Inputs/RoundedButton';
import { DS_SIZE_MAP } from 'Components/ComponentLibrary/DesignSystem/sizes';
import useResource from 'Hooks/useResource';
import fr from 'facet-rest';
import { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';

const useStyles = buildUseStyles('FeedbackAdditionalDetailsContent', ((theme) => ({
  root: {},
  content: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: theme.spacing(2),
    height: 250,
  },
  dialogActions: {
    display: 'flex',
    justifyContent: 'center',
  },
})));


const overrideSet = fr.metaOverride({ base: BaseOverrideNoHidden })
  .nameOverride('additionalDetails', {
    _hideLabel: true,
  });

const FeedbackAdditionalDetailsContent = ({ resource, onSubmit }) => {
  const classes = useStyles();

  const {
    setAttribute,
  } = useResource(resource);

  const handleOnSubmit = async () => {
    await resource.submit();
    if (onSubmit) {
      onSubmit();
    }
  };

  return <>
    <DialogTitle>
      <Title text={resource.attr('title')} />
    </DialogTitle>
    <DialogContent className={classes.content}>
      <Subtitle
        text={resource.attr('subtitle')}
        align={'left'}
      />
      <MetaControl
        attrName="additionalDetails"
        InputProps={{
          multiline: true,
          maxRows: 7,
          rows: 7,
          placeholder: 'Type your feedback here...',
        }}
        resource={resource}
        metaOverrideSet={overrideSet}
        fullWidth
        onChange={(value) => {
          setAttribute('additionalDetails', value);
        }}
      />
    </DialogContent>
    <DialogActions className={classes.dialogActions}>
      <RoundedButton
        onClick={handleOnSubmit}
        variant={'contained'}
        color={'primary'}
        fullWidth
        size={DS_SIZE_MAP.sm}
      >
      Submit
      </RoundedButton>
    </DialogActions>
  </>;
};

FeedbackAdditionalDetailsContent.defaultProps = {
};

FeedbackAdditionalDetailsContent.propTypes = {
};

export default FeedbackAdditionalDetailsContent;
